import { useOutletContext } from "react-router-dom";

const Header = () => {
  const [toggleOpen] = useOutletContext();

  return (
    <>
      <div className="header bg-white text-[#272727] z-20 sticky top-0 flex items-center justify-between shadow-[0_3px_3px_rgba(0,0,0,0.2)] px-5 py-3">
        <div className="page-title capitalize text-lg font-medium">Time<span className="text-[#EB4B50]">ly</span></div>
        <div
          className="menu-icon cursor-pointer select-none text-[#272727]"
          onClick={toggleOpen}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-7 h-7"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
            />
          </svg>
        </div>
      </div>
    </>
  );
};

export default Header;
